import { ComponentProps, FC, PropsWithChildren } from 'react';

import { ChannelErrors as VendorChannelErrors } from '@logux/client/react';

export const ChannelErrors = VendorChannelErrors as unknown as FC<
  PropsWithChildren<ComponentProps<typeof VendorChannelErrors>>
>;
